import { SyncDirection } from "../../../../../../common/sesh_types";
import { SyncEntity } from "../../../../../../src/entity/Sync";

export function SyncDirectionPreposition(props: { sync: SyncEntity }) {
	switch (props.sync.sync_direction) {
		case SyncDirection.Outbound:
		case SyncDirection.Inbound:
			return <p>to</p>;
	}
}
